<template>
  <v-footer class="d-flex flex-column pa-5" color="dark">
    <v-row class="d-flex w-100 justify-space-around">
      <v-col class="text-left">
        <v-footer-title
          >&copy; {{ new Date().getFullYear() }} Competiscan</v-footer-title
        >
      </v-col>
      <v-col>
        <a class="pa-5 footer-txtcolor">About Us</a>
        <a class="pa-5 footer-txtcolor">Services</a>
        <a class="pa-5 footer-txtcolor">Careers</a>
        <a class="pa-5 footer-txtcolor">Contact Us</a>
        <a class="pa-5 footer-txtcolor">About</a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
/* Add custom styles if needed */
/* .v-footer .v-theme--myCustomTheme {
  position: inherit !important;
} */

.link-clr {
  color: #3f51b5;
}

/* .pbottom {
  padding-bottom: 100px !important;
} */
</style>
